import React, { useEffect } from 'react';

const BookingCalendar = () => {
  useEffect(() => {
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement('script')).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ['initNamespace', namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');

    window.Cal('init', '30-min', { origin: 'https://app.cal.com' });
    window.Cal.ns['30-min']('inline', {
      elementOrSelector: '#my-cal-inline-30-min',
      config: { layout: 'month_view', useSlotsViewOnSmallScreen: 'true', theme: 'dark' },
      calLink: 'ilyalabs/30-min',
    });
    window.Cal.ns['30-min']('ui', { theme: 'dark', hideEventTypeDetails: false, layout: 'month_view' });
  }, []);

  return (
    <div id="booking-section" className="py-16 border-t" style={{ background: '#0a0a0a', borderColor: '#1a1a1a' }}>
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#4ade80' }}>Book a Call</p>
          <h2 className="text-3xl font-bold" style={{ color: '#f1f1f1' }}>Schedule a 30-minute discovery call.</h2>
        </div>
        <div className="rounded-2xl overflow-hidden border" style={{ borderColor: '#1f1f1f' }}>
          <div style={{ width: '100%', height: '900px', overflow: 'scroll' }} id="my-cal-inline-30-min" />
        </div>
      </div>
    </div>
  );
};

export default BookingCalendar;